import type { FetchQueryOptions, QueryKey } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import { getCurrentOrganisation } from "../root/CurrentOrganisationProvider";

export const prefetch = async <TData, TQueryKey extends QueryKey = QueryKey>(
  queryOptions: FetchQueryOptions<TData, Error, TData, TQueryKey>
): Promise<void> => {
  const currentOrganisation = await getCurrentOrganisation();
  if (currentOrganisation) queryClient.prefetchQuery(queryOptions);
};
